import { normalize } from './normalize'

// Takes a string and returns it in an url-compatible format
export const urlFriendly = (urlInput: string): string => {
    // replaces white spaces with dashes
    urlInput = urlInput.replace(/\s+/g, '-')

    // Replace accent characters with normal ones
    urlInput = normalize(urlInput)

    // Some replacements based on RequestHandlerSettings from Umbraco 13
    urlInput = urlInput.replace('+', 'plus')
    urlInput = urlInput.replace('*', 'star')
    urlInput = urlInput.replace('|', '-')

    // Replace special characters, except numbers, letters, hyphens and underscore
    urlInput = urlInput.replace(/[^a-zA-Z0-9-_]/g, '')

    // replaces all occurrences of two or more consecutive hyphens in a string with a single hyphen
    urlInput = urlInput.replace(/-{2,}/g, '-')

    urlInput = urlInput.toLowerCase()
    return urlInput
}
